import { PacksClient } from '../types'

export const moveToSuperpack = (base: PacksClient) => (packId: string, superpackId: string) =>
  base.requester.put<any>(`/${packId}`, { superpack_id: superpackId });
